<div [class]="'w-full h-[5vh] lg:h-[4.074vh] p-[0.7vh] lg:p-[0.555vh] background-stepper rounded-[1.5vh] ' + customClassContainer">
  <div [style]="'width:' + getProgressionBar() + '%'" [class]="'bg-green-400 h-full transition-all background-stepper rounded-[1.5vh] ' + customClassBar"></div>
</div>